import { CSSProperties } from 'react'
import { StyleImage } from './style'
interface IImage {
  src?: any
  width?: number
  height?: number
  radius?: number
  fit?: 'contain' | 'cover'
  customStyle?: CSSProperties | string
  onClick?: (event: any) => void
}
const Image = (props: IImage) => {
  return <StyleImage {...props} />
}

export default Image
